/* Rose & Fire — product page engine, "next" layout. SHOPIFY BUILD.
 *
 * Forked from assets/rf-pdp-next.js for the theme copy. The bundle follows
 * Mike's spec (Slack, 2026-10-01, 10-02 and 10-04):
 *   - "Add to bag" puts this cover in the real Shopify cart; the shopper stays.
 *   - Right under it, big: "Buy 2 or more to save up to 30% automatically"
 *     (was "Discount automatically applied at checkout" until Mike, 10-09).
 *   - One progress bar instead of the three tier rows (10-04): a step per
 *     cover up to the top tier, the tier over its step ("2 covers / 20% off"),
 *     "Current" under the tier the cart has reached, one short line on what
 *     the next cover gets. It counts the covers really in the cart. The tiers
 *     come from D.tiers (build_liquid.py): 2 covers 20%, 3+ 30% since 10-06.
 *   - Under it "Shop more covers" goes to the headcovers collection: an
 *     outline until this cover is in the bag, solid after. No Checkout button
 *     here (Dmytro, 10-05). The "4+ complete set" row and the "Your bag ...
 *     You save" line are gone (Mike: redundant).
 *   - The design picker (openSheet) is no longer linked from the bundle. It
 *     stays in the file; the rows version is rf-pdp-next.shopify.bak-rows.js.
 * The money comes off through Shopify automatic discounts; the bar only shows
 * the tiers.
 *
 * Data: the [data-n-data] blob (this design: snapshot plus live price and
 * stock, and the product's photos from Shopify as D.images), [data-n-live]
 * (this design's variants as the store has them now), [data-n-mixdata] (every
 * other design in the collection, live, from Liquid) and [data-n-sizes] (the
 * fit line per club size, from the "rf_size" metaobjects once they exist).
 *
 * Photos (Dmytro, 2026-10-08): the gallery is the product's own photos in the
 * admin order; a size opens its own photo; the big photo takes a swipe on a
 * phone, and a tap opens the photo viewer (zoom, swipe, arrows, Esc).
 */
(function () {
  'use strict';

  var root = document;
  var blob = document.querySelector('[data-n-data]');
  if (!blob) return;
  var D;
  try { D = JSON.parse(blob.textContent); } catch (e) { return; }

  var V = D.variants || [];
  var TIERS = (D.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });

  /* ------------------------------------------------------------- helpers -- */
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function clubName(n) {
    var t = String(n || '').toLowerCase();
    if (t.indexOf('driver') > -1) return 'Driver';
    if (t.indexOf('fairway') > -1 || t.indexOf('wood') > -1) return 'Fairway Wood';
    if (t.indexOf('hybrid') > -1 || t.indexOf('utility') > -1) return 'Hybrid';
    if (t.indexOf('mallet') > -1) return 'Mallet Putter';
    if (t.indexOf('putter') > -1 || t.indexOf('blade') > -1) return 'Standard Putter';
    return n;
  }
  // The store's variant label tidied for a tile, the same way the static build
  // does it (_source/build_pdp.py clean_variant): no material name, no closure,
  // handedness kept. Only shown where one design has two of the same club.
  function cleanVariant(t) {
    t = String(t || '').replace(/\s*Cordura\s*/g, ' ');
    var hand = '', par = t.match(/\((.*?)\)/);
    if (par && /handed/i.test(par[1])) hand = /right/i.test(par[1]) ? ' right handed' : ' left handed';
    return (t.replace(/\s*\(.*$/, '') + hand)
      .replace(/\s*Magnetic Closure\s*/gi, ' ')
      .replace(/\s*Putter Cover\s*/gi, ' Putter ')
      .replace(/Hybrid\/Ut[il]+ity/gi, 'Hybrid')
      .replace(/\s*with Velcro\s*/gi, ' ')
      .replace(/\s*Velcro\s*/gi, ' ')
      .replace(/\bLEFT HANDED\b/g, 'Left handed')
      .replace(/\bRIGHT HANDED\b/g, 'Right handed')
      .replace(/\s+/g, ' ').trim();
  }
  var SHORT = { 'Driver': 'Driver', 'Fairway Wood': 'Fairway', 'Hybrid': 'Hybrid',
                'Standard Putter': 'Putter', 'Mallet Putter': 'Mallet' };
  var CLUBS = ['Driver', 'Fairway Wood', 'Hybrid', 'Standard Putter', 'Mallet Putter'];
  function short(c) { return SHORT[c] || c; }
  function designName(t) { return String(t || '').replace(/\s+headcovers?$/i, ''); }
  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'], v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  function tierFor(n) { var t = null; TIERS.forEach(function (x) { if (n >= x.min) t = x; }); return t; }
  function pctFor(n) { var t = tierFor(n); return t ? t.pct : 0; }

  /* ------------------------------------------------- fit line by size ---- */
  // The line under the club tiles, by club size for the whole store (Mike's
  // size guide, Slack DM 2026-10-07). The "rf_size" metaobjects in Shopify
  // ([data-n-sizes]) replace this list once they exist, so Mike can edit a line
  // or add a size there. A variant takes the first size whose phrase is in its
  // Shopify name; one that matches none (the Mystery Box velcro covers) keeps
  // the snapshot's line.
  var DEFAULT_SIZES = [
    { name: 'Driver', match: 'driver', fit: 'Guaranteed to fit 420 to 460cc heads' },
    { name: 'Fairway Wood', match: 'fairway', fit: 'Fits fairway woods up to 260cc' },
    { name: 'Hybrid', match: 'hybrid, utility, utlity', fit: 'Cut for hybrids and utility clubs' },
    { name: 'Standard Putter', match: 'standard putter', fit: 'Strong magnetic closure. Fits cavity back blades' },
    { name: 'Center Shafted Mallet', match: 'center shaft, centre shaft, zero torque',
      fit: 'Fits center shafted mallets and mid-mallets, Zero Torque putters like DF3 and ZT included' },
    { name: 'Heel Shafted Mallet', match: 'heel shaft', fit: 'Fits heel shafted mallets and mid-mallets, right or left handed' },
    { name: 'Universal Mallet', match: 'universal, mallet putter magnetic',
      fit: 'Strong magnetic closure. Fits traditional heel and center shafted mallets, not DF3 or ZT' },
    // The Mystery Box velcro covers (their lines from its page).
    { name: 'Velcro Standard Putter', match: 'standard velcro', fit: 'Hook and loop closure. Fits cavity back blades' },
    { name: 'Velcro Mallet', match: 'mallet velcro', fit: 'Hook and loop closure. Fits mallets up to 4 inches deep' }
  ];
  var SIZES = [];
  try { SIZES = JSON.parse((q('[data-n-sizes]') || {}).textContent || '[]') || []; } catch (e) { SIZES = []; }
  if (!SIZES.length) SIZES = DEFAULT_SIZES;
  function sizeFit(title) {
    var t = String(title || '').toLowerCase();
    for (var i = 0; i < SIZES.length; i++) {
      var ph = String(SIZES[i].match || '').toLowerCase().split(',');
      for (var j = 0; j < ph.length; j++) {
        var p = ph[j].trim();
        if (p && t.indexOf(p) > -1) return SIZES[i].fit || '';
      }
    }
    return '';
  }

  /* ------------------------------------ variants, live from the store ---- */
  // The club tiles follow Shopify itself (Dmytro, 2026-10-07): a variant
  // renamed there shows its new name (Mike is renaming the old mallet to
  // "Universal Mallet"), a deleted one leaves the page, a new one appears in
  // the store's order. Since 2026-10-08 the gallery is live too, so a size
  // opens its own photo (its media id, "m"), then a gallery photo with its
  // file name, then the photo of a size of the same club. The fit line comes
  // from the size list above; the snapshot (D.variants) only lends what
  // Shopify does not give the page.
  function fileOf(u) { var m = String(u || '').split('?')[0].match(/([^\/]+)$/); return m ? m[1] : ''; }
  function slideOf(u) {
    var f = fileOf(u);
    for (var i = 0; f && i < (D.images || []).length; i++) if (fileOf(D.images[i].big) === f) return i;
    return -1;
  }
  function slideById(id) {
    for (var i = 0; id && i < (D.images || []).length; i++) if (String(D.images[i].id) === String(id)) return i;
    return -1;
  }
  (function () {
    var live = null;
    try { live = JSON.parse((q('[data-n-live]') || {}).textContent || 'null'); } catch (e) { live = null; }
    if (!live || !live.length) return;
    var snap = {}, like = {};
    V.forEach(function (v) {
      snap[v.id] = v;
      var c = clubName(v.name);
      if (!like[c]) like[c] = v;
    });
    V = live.map(function (x) {
      var s = snap[x.id], name = cleanVariant(x.t);
      if (!name || /^default title$/i.test(name)) name = s ? s.name : designName(D.title);
      var l = like[clubName(name)];
      var mi = slideById(x.m);
      if (mi < 0) mi = slideOf(x.i);
      if (mi < 0 && s) mi = slideOf(s.thumb);
      if (mi < 0 && l) mi = slideOf(l.thumb);
      if (mi < 0) mi = s && typeof s.mediaIndex === 'number' && s.mediaIndex < (D.images || []).length ? s.mediaIndex : 0;
      // A size without a photo of its own shows the product's main photo on
      // its tile (Mystery Box, Zombie's sold-out sizes): no empty image.
      return { id: x.id, name: name, price: x.p, available: x.a, mediaIndex: mi,
               thumb: x.i || (s ? s.thumb : '') || (l ? l.thumb : '') ||
                      ((D.images && D.images[0]) ? (D.images[0].thumb || D.images[0].big) : ''),
               fit: sizeFit(x.t) || (s ? s.fit : '') || (l ? l.fit : '') };
    });
  })();

  /* ------------------------------------------------------------ designs --- */
  var THIS = {
    h: D.handle, t: designName(D.title),
    i: (D.images && D.images[0] && D.images[0].big) || '',
    v: V.map(function (v) { return { id: v.id, n: clubName(v.name), l: v.name, p: v.price, a: v.available }; })
  };
  var MIX = [];
  try { MIX = JSON.parse((q('[data-n-mixdata]') || {}).textContent || '[]'); } catch (e) { MIX = []; }
  MIX.forEach(function (d) { d.t = designName(d.t); (d.v || []).forEach(function (v) { v.l = cleanVariant(v.n); v.n = clubName(v.n); }); });
  // The cross-sell picks first, Mystery Box last (the buyer does not choose its design).
  (function () {
    var first = D.mixFirst || [];
    MIX.sort(function (a, b) {
      var ma = a.h.indexOf('mystery') > -1 ? 1 : 0, mb = b.h.indexOf('mystery') > -1 ? 1 : 0;
      if (ma !== mb) return ma - mb;
      var ia = first.indexOf(a.h), ib = first.indexOf(b.h);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
  })();
  // The "What's next in your bag" cards (rf-pdp.js) were cut from the snapshot
  // too. Their size pills follow the store the same way: one per variant in
  // stock, in the store's order, under its current name and price, and "from"
  // is the cheapest of them. A pill already on the page keeps its rf-pdp.js
  // click handler; a new one gets the same handler here. A design missing from
  // the collection data keeps the pills it was built with.
  (function () {
    var byH = {};
    MIX.forEach(function (d) { byH[d.h] = d; });
    function bindAdd(b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'rf_xsell_add', item: b.getAttribute('data-rf-xname') }); } catch (e) {}
        window.RFCART.add([{ id: parseInt(b.getAttribute('data-rf-xadd'), 10), quantity: 1 }], {
          onDone: function () { b.disabled = false; var c = b.closest('[data-rf-xcard]'); if (c) c.classList.remove('is-open'); },
          onFail: function () { b.disabled = false; }
        });
      });
    }
    qa('[data-rf-xcard]').forEach(function (card) {
      var a = q('a[href^="/products/"]', card), wrap = q('[data-rf-xpills]', card);
      var d = a && byH[a.getAttribute('href').replace(/^\/products\//, '').split(/[?#]/)[0]];
      if (!d || !wrap || !window.RFCART) return;
      var old = {};
      qa('[data-rf-xadd]', wrap).forEach(function (b) { old[b.getAttribute('data-rf-xadd')] = b; });
      var title = (q('.rf-x__name', card) || {}).textContent || d.t, low = null;
      wrap.innerHTML = '';
      (d.v || []).forEach(function (v) {
        if (!v.a) return;
        var b = old[String(v.id)];
        if (!b) {
          b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('data-rf-xadd', v.id);
          bindAdd(b);
        }
        b.textContent = v.l + ' · ' + money(v.p);
        b.setAttribute('data-rf-xname', title + ' · ' + v.l);
        wrap.appendChild(b);
        if (low === null || v.p < low) low = v.p;
      });
      var pr = q('.rf-x__price', card);
      if (pr && low !== null) pr.textContent = 'from ' + money(low);
    });
  })();
  var DES = MIX.concat([THIS]);
  var HANDLES = {};
  DES.forEach(function (d) { HANDLES[d.h] = true; });
  function design(h) { for (var i = 0; i < DES.length; i++) if (DES[i].h === h) return DES[i]; return null; }
  // A design's variant for a club, an in-stock one first: Candy Skull has two
  // mallets and the Mystery Box three, so the first one may be sold out.
  function variantFor(d, club) {
    var first = null;
    for (var i = 0; i < (d.v || []).length; i++) {
      if (d.v[i].n !== club) continue;
      if (d.v[i].a) return d.v[i];
      if (!first) first = d.v[i];
    }
    return first;
  }
  // Two of the same club on one design (heel shafted and center shaft mallet)
  // each get their own tile under their own name; every other club stays one tile.
  function twin(d, v) { return (d.v || []).filter(function (x) { return x.n === v.n; }).length > 1; }
  function picksOf(d) {
    var out = [];
    CLUBS.forEach(function (c) { (d.v || []).forEach(function (v) { if (v.n === c) out.push(v); }); });
    return out;
  }

  /* --------------------------------------------------------------- state -- */
  var firstAvailable = V.filter(function (v) { return v.available; })[0] || V[0];
  var state = { primary: firstAvailable ? firstAvailable.id : null, slide: 0 };
  var CART = { items: [], total_price: 0, total_discount: 0 };

  function byId(id) {
    for (var i = 0; i < V.length; i++) if (String(V[i].id) === String(id)) return V[i];
    return null;
  }
  function primary() { return byId(state.primary); }

  /* ---------------------------------------------------------------- cart -- */
  function coverLines() { return (CART.items || []).filter(function (it) { return HANDLES[it.handle]; }); }
  function cartCovers() { return coverLines().reduce(function (n, it) { return n + it.quantity; }, 0); }
  function thisInCart() {
    var p = primary();
    return !!(p && (CART.items || []).some(function (it) { return String(it.variant_id) === String(p.id); }));
  }
  // What the rows count from: every cover in the cart, plus this one if it is not in yet.
  function base() { return cartCovers() + (thisInCart() ? 0 : 1); }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c || CART; headerCount(); return CART; })
      .catch(function () { return CART; });
  }
  // The shopper stays on the page after Add to bag (Mike's spec) and sees the
  // discount bar move. The Qikify Sticky Cart app opens its drawer over the
  // whole page on every /cart/add it sees, so the add tells it to stay quiet
  // (its own "sc-silently-change-cart" flag) and then asks it to refresh its
  // cart without opening (Dmytro, 2026-10-09). Its cart icon opens it as before.
  function qikifyRefresh() {
    try { document.dispatchEvent(new Event('ajax-cart:changed')); } catch (e) {}
  }
  function cartAdd(items) {
    return fetch('/cart/add.js?sc-silently-change-cart=true', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to the bag. Please try again.');
        return j;
      });
    }).then(function () { qikifyRefresh(); return fetchCart(); });
  }
  // The theme header prints "Cart (n)"; keep it honest without a reload.
  function headerCount() {
    var n = CART.item_count || 0;
    qa('a.cart-count').forEach(function (a) { a.innerHTML = a.innerHTML.replace(/\(\d+\)/, '(' + n + ')'); });
  }
  // Shopify's numbers once automatic discounts exist; until then the tier maths.
  function bagTotals() {
    var full = (CART.items || []).reduce(function (s, it) { return s + (it.original_line_price || it.line_price || 0); }, 0);
    if (CART.total_discount > 0) return { full: full, total: CART.total_price, save: CART.total_discount };
    var pct = pctFor(cartCovers()), save = 0;
    coverLines().forEach(function (it) { save += Math.round((it.original_line_price || it.line_price) * pct / 100); });
    return { full: full, total: full - save, save: save };
  }

  /* ------------------------------------------------------------ gallery --- */
  var stageImg = q('[data-n-img]');
  var countEl = q('[data-n-count]');
  var thumbsWrap = q('.n-gal__thumbs');
  function showSlide(i) {
    var imgs = D.images || [];
    if (!imgs.length) return;
    state.slide = Math.max(0, Math.min(i, imgs.length - 1));
    if (stageImg) {
      stageImg.src = imgs[state.slide].big;
      stageImg.alt = imgs[state.slide].alt || (D.title + ' image ' + (state.slide + 1));
    }
    if (countEl) countEl.textContent = (state.slide + 1) + ' / ' + imgs.length;
    qa('[data-n-thumb]').forEach(function (b) {
      var on = parseInt(b.getAttribute('data-n-thumb'), 10) === state.slide;
      b.setAttribute('aria-current', on ? 'true' : 'false');
      // Keep the current thumbnail in view inside its row, without moving the page.
      if (on && thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        thumbsWrap.scrollLeft = b.offsetLeft - thumbsWrap.offsetLeft - (thumbsWrap.clientWidth - b.offsetWidth) / 2;
      }
    });
  }
  qa('[data-n-thumb]').forEach(function (b) {
    b.addEventListener('click', function () { showSlide(parseInt(b.getAttribute('data-n-thumb'), 10)); });
  });

  /* ------------------------------------------- photo viewer and swipe --- */
  // Dmytro, 2026-10-08: click a product photo and see it up close. A tap on the
  // big photo or its magnifier opens the photos full screen at full size: a
  // swipe or the arrows step through them, a pinch or a double tap zooms on a
  // phone, a click zooms on a computer and the photo follows the mouse; Esc,
  // the cross or a tap beside the photo closes it on the photo it was left at.
  // On the page itself the big photo takes a swipe on a phone.
  (function () {
    var stage = q('.n-gal__stage');
    var IM = D.images || [];
    if (!stage || !stageImg || !IM.length) return;
    var many = IM.length > 1;
    function wrap(i) { return (i + IM.length) % IM.length; }

    // Swipe on the big photo. 45px and mostly sideways, so scrolling the page
    // over the photo never turns it; the tap that ends a swipe opens nothing.
    var sw = null, swiped = 0;
    stage.addEventListener('touchstart', function (e) {
      sw = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() } : null;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var st = sw;
      sw = null;
      if (!st || !many) return;
      var t = e.changedTouches[0], dx = t.clientX - st.x, dy = t.clientY - st.y;
      if (Date.now() - st.t > 800) return;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      swiped = Date.now();
      showSlide(wrap(state.slide + (dx < 0 ? 1 : -1)));
    }, { passive: true });

    var box = document.createElement('div');
    box.className = 'n-zoom';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', designName(D.title) + ' photos');
    box.innerHTML = '<div class="n-zoom__stage"><img class="n-zoom__img" alt="" draggable="false"></div>' +
      '<button type="button" class="n-zoom__x" aria-label="Close">&times;</button>' +
      (many ? '<button type="button" class="n-zoom__nav n-zoom__prev" aria-label="Previous photo">&#8249;</button>' +
              '<button type="button" class="n-zoom__nav n-zoom__next" aria-label="Next photo">&#8250;</button>' +
              '<span class="n-zoom__count" aria-live="polite"></span>' : '');
    (q('.rfx') || document.body).appendChild(box);
    var zStage = q('.n-zoom__stage', box), zImg = q('.n-zoom__img', box), zCount = q('.n-zoom__count', box);
    var zClose = q('.n-zoom__x', box);
    var idx = 0, s = 1, tx = 0, ty = 0, MAX = 4, STEP = 2.5;
    var back = null, touchedAt = 0, saved = null;

    function apply(anim) {
      box.classList.toggle('is-zoomed', s > 1.01);
      zImg.style.transition = anim ? '' : 'none';
      zImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
    }
    function bounds() {
      return { x: Math.max(0, (zImg.offsetWidth * s - zStage.clientWidth) / 2),
               y: Math.max(0, (zImg.offsetHeight * s - zStage.clientHeight) / 2) };
    }
    function clamp() {
      var b = bounds();
      tx = Math.max(-b.x, Math.min(b.x, tx));
      ty = Math.max(-b.y, Math.min(b.y, ty));
    }
    function reset(anim) { s = 1; tx = 0; ty = 0; apply(anim); }
    // Zoom to n keeping the screen point (px, py) where it is.
    function zoomAt(n, px, py, anim) {
      var r = zStage.getBoundingClientRect();
      var cx = px - (r.left + r.width / 2), cy = py - (r.top + r.height / 2);
      n = Math.max(1, Math.min(MAX, n));
      tx = cx - (cx - tx) * (n / s);
      ty = cy - (cy - ty) * (n / s);
      s = n;
      if (s <= 1.01) { s = 1; tx = 0; ty = 0; }
      clamp();
      apply(anim);
    }
    function show(i) {
      idx = wrap(i);
      var m = IM[idx], want = idx;
      reset(false);
      zImg.src = m.big;
      zImg.alt = m.alt || (D.title + ' image ' + (idx + 1));
      // The large file replaces the page-size one once it has loaded.
      if (m.zoom && m.zoom !== m.big) {
        var pre = new Image();
        pre.onload = function () { if (want === idx && !box.hidden) zImg.src = m.zoom; };
        pre.src = m.zoom;
      }
      if (zCount) zCount.textContent = (idx + 1) + ' / ' + IM.length;
    }
    function open(i) {
      back = document.activeElement;
      saved = { h: document.documentElement.style.overflow, b: document.body.style.overflow };
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      box.hidden = false;
      show(i);
      zClose.focus();
    }
    function close() {
      if (box.hidden) return;
      box.hidden = true;
      if (saved) { document.documentElement.style.overflow = saved.h; document.body.style.overflow = saved.b; }
      showSlide(idx);
      if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
    }

    stage.addEventListener('click', function () {
      if (Date.now() - swiped < 350) return;
      open(state.slide);
    });
    zClose.addEventListener('click', close);
    if (many) {
      q('.n-zoom__prev', box).addEventListener('click', function () { show(idx - 1); });
      q('.n-zoom__next', box).addEventListener('click', function () { show(idx + 1); });
    }
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft' && many) show(idx - 1);
      else if (e.key === 'ArrowRight' && many) show(idx + 1);
      else if (e.key === 'Tab') {
        // Keep the keyboard inside the viewer.
        var f = qa('button', box);
        var at = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(at + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
    window.addEventListener('resize', function () { if (!box.hidden) reset(false); });

    // Mouse: a click on the photo zooms in at that point and the photo follows
    // the mouse; a second click zooms out; a click beside the photo closes.
    zStage.addEventListener('click', function (e) {
      if (Date.now() - touchedAt < 800) return;
      if (e.target !== zImg) { close(); return; }
      if (s > 1.01) reset(true); else zoomAt(STEP, e.clientX, e.clientY, true);
    });
    zStage.addEventListener('mousemove', function (e) {
      if (s <= 1.01 || Date.now() - touchedAt < 800) return;
      var r = zStage.getBoundingClientRect(), b = bounds();
      tx = -((e.clientX - r.left) / r.width - 0.5) * 2 * b.x;
      ty = -((e.clientY - r.top) / r.height - 0.5) * 2 * b.y;
      apply(false);
    });

    // Touch: pinch to zoom around the fingers, drag to move a zoomed photo,
    // swipe to the next photo, double tap to zoom in or out, a single tap
    // beside the photo closes.
    var g = null, lastTap = null, tapTimer = 0;
    function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    function center(r) { return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    zStage.addEventListener('touchstart', function (e) {
      touchedAt = Date.now();
      box.classList.add('is-dragging');
      if (e.touches.length === 2) {
        var a = e.touches[0], b = e.touches[1], c = center(zStage.getBoundingClientRect());
        g = { mode: 'pinch', d: dist(a, b), s: s, tx: tx, ty: ty,
              cx: (a.clientX + b.clientX) / 2 - c.x, cy: (a.clientY + b.clientY) / 2 - c.y };
      } else if (e.touches.length === 1) {
        var t = e.touches[0];
        g = { mode: s > 1.01 ? 'pan' : 'swipe', x: t.clientX, y: t.clientY, tx: tx, ty: ty, t: Date.now() };
      }
    }, { passive: true });
    zStage.addEventListener('touchmove', function (e) {
      if (!g) return;
      if (e.cancelable) e.preventDefault();
      if (g.mode === 'pinch' && e.touches.length === 2) {
        var a = e.touches[0], b = e.touches[1], c = center(zStage.getBoundingClientRect());
        var n = Math.max(1, Math.min(MAX, g.s * dist(a, b) / g.d));
        var mx = (a.clientX + b.clientX) / 2 - c.x, my = (a.clientY + b.clientY) / 2 - c.y;
        tx = mx - (g.cx - g.tx) * (n / g.s);
        ty = my - (g.cy - g.ty) * (n / g.s);
        s = n;
        clamp();
        apply(false);
      } else if (g.mode === 'pan' && e.touches.length === 1) {
        var t = e.touches[0];
        tx = g.tx + (t.clientX - g.x);
        ty = g.ty + (t.clientY - g.y);
        clamp();
        apply(false);
      }
    }, { passive: false });
    function endTouch(e) {
      box.classList.remove('is-dragging');
      if (!g) return;
      var was = g;
      if (e.touches && e.touches.length === 1 && was.mode === 'pinch') {
        // One finger left after a pinch: carry on as a drag.
        var t1 = e.touches[0];
        g = { mode: 'pan', x: t1.clientX, y: t1.clientY, tx: tx, ty: ty, t: Date.now() };
        return;
      }
      if (e.touches && e.touches.length) return;
      g = null;
      if (was.mode === 'pinch') { if (s <= 1.05) reset(true); return; }
      var t = e.changedTouches[0], dx = t.clientX - was.x, dy = t.clientY - was.y, dt = Date.now() - was.t;
      if (was.mode === 'swipe' && many && dt < 800 && Math.abs(dx) >= 45 && Math.abs(dx) >= Math.abs(dy) * 1.4) {
        show(idx + (dx < 0 ? 1 : -1));
        return;
      }
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10 || dt > 350) return;
      var now = Date.now();
      if (lastTap && now - lastTap.t < 320 && Math.abs(t.clientX - lastTap.x) < 30 && Math.abs(t.clientY - lastTap.y) < 30) {
        clearTimeout(tapTimer);
        lastTap = null;
        if (s > 1.01) reset(true); else zoomAt(STEP, t.clientX, t.clientY, true);
        return;
      }
      lastTap = { t: now, x: t.clientX, y: t.clientY };
      var onPhoto = e.target === zImg;
      tapTimer = setTimeout(function () { lastTap = null; if (!onPhoto && s <= 1.01) close(); }, 330);
    }
    zStage.addEventListener('touchend', endTouch);
    zStage.addEventListener('touchcancel', function () { g = null; box.classList.remove('is-dragging'); });
  })();

  /* ------------------------------------------------- step 1: club tiles --- */
  var tilesWrap = q('[data-n-tiles]');
  function tileHtml(v) {
    var sold = !v.available, on = String(v.id) === String(state.primary);
    return '<button type="button" class="n-tile' + (sold ? ' is-sold' : '') + (on ? ' is-on' : '') + '"' +
      ' data-n-tile="' + esc(v.id) + '"' + (sold ? ' aria-disabled="true"' : '') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="n-tile__sh">' + (v.thumb ? '<img src="' + esc(v.thumb) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="n-tile__c"><b>' + esc(v.name) + '</b><small>' + (sold ? 'Sold out' : money(v.price)) + '</small></span></button>';
  }
  // Every size is a tile, sold out ones included (grey, "Sold out", a tap opens
  // the restock form). Folding them into a line under the tiles was tried on
  // the preview on 2026-10-09 and dropped: Dmytro could not find Fairway Wood.
  function renderTiles() {
    if (!tilesWrap) return;
    tilesWrap.innerHTML = V.map(tileHtml).join('');
    qa('[data-n-tile]', tilesWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = byId(b.getAttribute('data-n-tile'));
        if (!v) return;
        if (!v.available) { openNotify(v); return; }
        state.primary = v.id;
        state.picked = true;
        if (typeof v.mediaIndex === 'number') showSlide(v.mediaIndex);
        sync();
      });
    });
  }

  /* ------------------------ the bundle: progress bar (Mike, 2026-10-04) --- */
  var bagWrap = q('[data-n-bag]');
  // The bar runs from 1 to the top tier (3 today, shown as "3+").
  var STEPS = TIERS.length ? Math.max(2, TIERS[TIERS.length - 1].min) : 4;
  function tierAt(s) { for (var i = 0; i < TIERS.length; i++) if (TIERS[i].min === s) return TIERS[i]; return null; }
  function covers(n) { return n + ' cover' + (n === 1 ? '' : 's'); }
  // The one line over the bar: what the bag has unlocked and what the next cover gets.
  function nudgeHtml(n) {
    var top = TIERS.length ? TIERS[TIERS.length - 1] : null;
    if (!n) return top ? 'Mix ' + TIERS[0].min + '+ covers and save up to&nbsp;<b>' + top.pct + '%</b>' : '';
    var cur = tierFor(n), next = null;
    TIERS.forEach(function (t) { if (!next && t.min > n) next = t; });
    if (!next) return '<b>' + cur.pct + '%&nbsp;off</b> every cover in your bag';
    var need = next.min - n;
    return (cur ? '<b>' + cur.pct + '%&nbsp;off</b> unlocked &middot; ' : '') +
      need + '&nbsp;more&nbsp;cover' + (need === 1 ? '' : 's') + ' for&nbsp;<b>' + next.pct + '%&nbsp;off</b>';
  }
  function progressHtml() {
    var n = cartCovers(), at = Math.min(n, STEPS), cur = tierFor(n), steps = '', nextMin = 0;
    TIERS.forEach(function (x) { if (!nextMin && x.min > n) nextMin = x.min; });
    for (var s = 1; s <= STEPS; s++) {
      var t = tierAt(s), isCur = !!(cur && t && cur.min === t.min);
      // Once a tier is reached every step gets the "Current" slot, filled or
      // not, so the labels stay on one line and the dots on another. The tier
      // the shopper is working towards is the one in full ink.
      steps += '<li class="n-prog__s' + (at >= s ? ' is-on' : '') + (isCur ? ' is-cur' : '') +
        (t && t.min === nextMin ? ' is-next' : '') + '">' +
        '<span class="n-prog__l">' + (t ? '<b>' + s + (s === STEPS ? '+' : '') + ' covers</b>' + t.pct + '% off' : '') + '</span>' +
        (cur ? '<span class="n-prog__c">' + (isCur ? '&#10003; Current' : '') + '</span>' : '') +
        '<span class="n-prog__d">' + s + '</span></li>';
    }
    var said = (n ? covers(n) + ' in your bag' + (cur ? ', ' + cur.pct + '% off' : '') : 'No covers in your bag yet') + '. ' +
      TIERS.map(function (t, i) { return t.min + (i === TIERS.length - 1 ? ' or more' : '') + ' covers: ' + t.pct + '% off'; }).join(', ') + '.';
    var nudge = nudgeHtml(n);
    return '<div class="n-prog" role="group" aria-label="' + esc(said) + '">' +
      (nudge ? '<p class="n-prog__m">' + nudge + '</p>' : '') +
      '<ol class="n-prog__ol" aria-hidden="true" style="--n-steps:' + STEPS + ';--n-f:' +
      (at > 1 ? ((at - 1) / (STEPS - 1)).toFixed(4) : 0) + '">' + steps + '</ol></div>';
  }
  // Until this page's cover is in the bag the button is an outline, so it does
  // not pull the shopper off the page before Add to bag; then it goes solid.
  function actionsHtml() {
    return '<div class="n-act"><a class="n-more' + (thisInCart() ? '' : ' is-ghost') +
      '" href="/collections/headcovers">Shop more covers <span aria-hidden="true">&rsaquo;</span></a></div>';
  }
  // The green headline says how to get the discount, not only that it applies
  // (Mike, #roseandfire-chat 2026-10-09: his dad read "Discount automatically
  // applied at checkout" and did not see how to get it). Numbers from TIERS.
  function autoHeadline() {
    if (!TIERS.length) return 'Discount automatically applied at checkout';
    return 'Buy ' + TIERS[0].min + ' or more to save up to ' + TIERS[TIERS.length - 1].pct + '% automatically';
  }
  function renderBag() {
    if (!bagWrap) return;
    bagWrap.innerHTML = '<div class="n-bund__auto"><b>&#10003; ' + autoHeadline() + '</b>' +
      '<small>No code needed. Mix any designs.</small></div>' +
      progressHtml() + actionsHtml() + '<p class="n-bund__err" data-n-bunderr hidden></p>';
  }
  function bundleError(msg) {
    var p = q('[data-n-bunderr]');
    if (!p) return;
    p.textContent = msg;
    p.hidden = !msg;
  }

  /* ----------------------------------------------------------- toast --- */
  var toastEl = null, toastT = null;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'n-toast';
      toastEl.setAttribute('role', 'status');
      (q('.rfx') || document.body).appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.hidden = true; }, 3400);
  }
  function unlockMsg(before, after) {
    var t = tierFor(after);
    return t && pctFor(after) > pctFor(before) ? ' &middot; <b>' + t.pct + '% off every cover</b>' : '';
  }

  /* ------------------------------------------------------- the picker --- */
  // Every design, then the club, laid out like step 1. No horizontal scroll.
  var sheet = null, CH = { step: 'design', club: null, h: null, pick: null }, lastFocus = null;
  function haveClubs() {
    var out = coverLines().map(function (it) { return clubName(it.variant_title); });
    var p = primary(); if (p && !thisInCart()) out.push(clubName(p.name));
    return out;
  }
  // The club a golfer most likely still needs: the first one not in the bag.
  function suggestClub(d) {
    var have = haveClubs();
    var order = ['Driver', 'Fairway Wood', 'Hybrid', 'Standard Putter', 'Mallet Putter'];
    for (var i = 0; i < order.length; i++) {
      var v = variantFor(d, order[i]);
      if (v && v.a && have.indexOf(order[i]) < 0) return order[i];
    }
    var any = (d.v || []).filter(function (v) { return v.a; })[0];
    return any ? any.n : null;
  }
  // The variant the club step has on: the shopper's tap (a variant id), else
  // the club the chip filtered on, else the club they most likely still need.
  function pickedVariant(d) {
    for (var i = 0; CH.pick && i < (d.v || []).length; i++) if (String(d.v[i].id) === CH.pick) return d.v[i];
    return variantFor(d, CH.club && variantFor(d, CH.club) && variantFor(d, CH.club).a ? CH.club : suggestClub(d));
  }
  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'n-sheet';
    sheet.hidden = true;
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = '<div class="n-sheet__in"><div class="n-sheet__hd" data-n-sh-hd></div><div class="n-sheet__body" data-n-sh-body></div></div>';
    (q('.rfx') || document.body).appendChild(sheet);
    sheet.addEventListener('click', onSheetClick);
  }
  function sheetTexts() {
    var b = base(), n = b + 1, t = tierFor(n);
    var off = t ? t.pct : pctFor(b);
    var sub = t && pctFor(n) > pctFor(b) ? 'This one unlocks ' + t.pct + '% off every cover' : (off ? 'Every cover gets ' + off + '% off' : '');
    return { title: 'Pick your ' + ordinal(n) + ' cover', sub: sub, off: off };
  }
  function renderSheet() {
    if (!sheet) return;
    var tx = sheetTexts(), off = tx.off, body;
    q('[data-n-sh-hd]', sheet).innerHTML = '<div class="n-sheet__row"><b>' + tx.title + '</b>' +
      '<button type="button" class="n-sheet__x" data-n-sh-close aria-label="Close">&times;</button></div>' +
      (tx.sub ? '<p class="n-sheet__sub">' + tx.sub + '</p>' : '');
    if (CH.step === 'design') {
      var chips = '<div class="n-chips">' + ['any'].concat(CLUBS).map(function (x) {
        var on = (x === 'any' && !CH.club) || x === CH.club;
        return '<button type="button" class="n-chip' + (on ? ' is-on' : '') + '" data-n-chip="' + x + '">' + (x === 'any' ? 'All designs' : short(x)) + '</button>';
      }).join('') + '</div>';
      var inBag = {};
      coverLines().forEach(function (it) { inBag[it.handle] = true; });
      var list = DES.filter(function (d) {
        if (!CH.club) return (d.v || []).some(function (v) { return v.a; });
        var v = variantFor(d, CH.club); return v && v.a;
      });
      body = chips + '<div class="n-dg">' + list.map(function (d) {
        var av = (d.v || []).filter(function (v) { return v.a && (!CH.club || v.n === CH.club); });
        var from = Math.min.apply(null, av.map(function (v) { return v.p; }));
        var a = Math.round(from * (100 - off) / 100);
        return '<button type="button" class="n-dgc' + (inBag[d.h] ? ' is-in' : '') + '" data-n-chd="' + esc(d.h) + '">' +
          '<img src="' + esc(d.i) + '" alt="" loading="lazy" draggable="false"><b>' + esc(d.t) + (inBag[d.h] ? ' &#10003;' : '') + '</b>' +
          '<small>from ' + (a < from ? '<s>' + money(from) + '</s> <em>' + money(a) + '</em>' : money(from)) + '</small></button>';
      }).join('') + '</div>';
    } else {
      var d = design(CH.h);
      var v = pickedVariant(d);
      body = '<button type="button" class="n-sheet__back" data-n-chback>&lsaquo; All designs</button>' +
        '<div class="n-sheet__pd"><img src="' + esc(d.i) + '" alt=""><b>' + esc(d.t) + '</b></div>' +
        '<div class="n-step"><b>Choose the club</b></div><div class="n-ptiles">' + picksOf(d).map(function (y) {
          var a = Math.round(y.p * (100 - off) / 100);
          return '<button type="button" class="n-ptile' + (y === v ? ' is-on' : '') + '" data-n-chpick="' + esc(y.id) + '"' + (y.a ? '' : ' disabled') + '>' +
            '<img src="' + esc(d.i) + '" alt=""><span><b>' + esc(twin(d, y) ? y.l || y.n : y.n) + '</b><small>' +
            (y.a ? (a < y.p ? '<s>' + money(y.p) + '</s> <em>' + money(a) + '</em>' : money(y.p)) : 'Sold out') + '</small></span></button>';
        }).join('') + '</div>' +
        '<p class="n-sheet__err" data-n-sherr hidden></p>' +
        '<button type="button" class="n-cta n-sheet__add" data-n-chadd' + (v && v.a ? '' : ' disabled') + '>Add to bag &middot; ' + money(Math.round(v.p * (100 - off) / 100)) + '</button>';
    }
    q('[data-n-sh-body]', sheet).innerHTML = body;
  }
  function openSheet() {
    if (!sheet) buildSheet();
    CH = { step: 'design', club: null, h: null, pick: null };
    lastFocus = document.activeElement;
    renderSheet();
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    var x = q('[data-n-sh-close]', sheet); if (x) x.focus();
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onSheetClick(ev) {
    var t;
    if (ev.target === sheet || ev.target.closest('[data-n-sh-close]')) { closeSheet(); return; }
    if ((t = ev.target.closest('[data-n-chip]'))) { var x = t.getAttribute('data-n-chip'); CH.club = x === 'any' ? null : x; renderSheet(); return; }
    if ((t = ev.target.closest('[data-n-chd]'))) { CH.h = t.getAttribute('data-n-chd'); CH.step = 'club'; CH.pick = null; renderSheet(); q('[data-n-sh-body]', sheet).scrollTop = 0; return; }
    if (ev.target.closest('[data-n-chback]')) { CH.step = 'design'; renderSheet(); return; }
    if ((t = ev.target.closest('[data-n-chpick]'))) { CH.pick = t.getAttribute('data-n-chpick'); renderSheet(); return; }
    if ((t = ev.target.closest('[data-n-chadd]'))) {
      var d = design(CH.h);
      var v = pickedVariant(d), p = primary();
      if (!v || !v.a) return;
      var before = cartCovers(), items = [], names = [];
      // "Make it a pair" is this cover plus another.
      if (p && p.available && !thisInCart()) { items.push({ id: p.id, quantity: 1 }); names.push(esc(THIS.t) + ' ' + short(clubName(p.name))); }
      if (p && String(v.id) === String(p.id) && items.length) items[0].quantity += 1;
      else items.push({ id: v.id, quantity: 1 });
      names.push(esc(d.t) + ' ' + esc(twin(d, v) ? v.l || v.n : short(v.n)));
      t.disabled = true;
      cartAdd(items).then(function () {
        closeSheet();
        toast('&#10003; Added ' + names.join(' + ') + unlockMsg(before, cartCovers()));
        sync();
      }).catch(function (err) {
        t.disabled = false;
        var e = q('[data-n-sherr]', sheet); if (e) { e.textContent = err.message; e.hidden = false; }
      });
    }
  }
  if (bagWrap) {
    bagWrap.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-n-row]')) openSheet();
    });
  }

  /* ------------------------------------------------------------ notify --- */
  // "Notify me" puts the shopper on Klaviyo's back-in-stock list for that size
  // (Mike, 2026-10-09: it opened an email to customer service, so nobody was
  // notified and the address never reached Klaviyo). Klaviyo's Back in Stock
  // flow emails them when the size is back. Client API, public site key only.
  var KLAVIYO_SITE = 'mufwuE';
  var notifyIds = [];
  function bisSubscribe(email, variantId) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + KLAVIYO_SITE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      } })
    }).then(function (r) {
      if (r.ok) return;
      return r.text().catch(function () { return ''; }).then(function (t) {
        var e = new Error('back in stock ' + r.status);
        e.email = r.status === 400 && /email/i.test(t);   // Klaviyo turned the address down
        throw e;
      });
    });
  }
  var notifyWrap = q('[data-n-notify]');
  function notifyMsg(form, ok, text) {
    var done = q('[data-n-notify-done]', form);
    if (!done) return;
    done.textContent = text;
    done.style.color = ok ? '' : '#c8102e';
    done.hidden = false;
  }
  function openNotify(v) {
    if (!notifyWrap) return;
    notifyWrap.hidden = false;
    notifyIds = [v.id];
    var f = q('[data-n-notify-variant]', notifyWrap); if (f) f.value = D.title + ' ' + v.name;
    var lbl = q('[data-n-notify-name]', notifyWrap); if (lbl) lbl.textContent = v.name;
    var done = q('[data-n-notify-done]', notifyWrap); if (done) done.hidden = true;
    var inp = q('input[type=email]', notifyWrap); if (inp) inp.focus();
  }
  var notifyForm = q('[data-n-notify-form]');
  if (notifyForm) {
    notifyForm.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var input = q('input[type=email]', notifyForm), btn = q('button[type=submit]', notifyForm);
      var email = String((input || {}).value || '').trim();
      // A design sold out in every size: one alert per size, whichever comes back first.
      var ids = notifyIds.length ? notifyIds : V.filter(function (v) { return !v.available; }).map(function (v) { return v.id; });
      if (!email || !ids.length) return;
      if (btn) btn.disabled = true;
      Promise.all(ids.map(function (id) { return bisSubscribe(email, id); })).then(function () {
        var name = (q('[data-n-notify-name]', notifyForm) || {}).textContent || 'size';
        notifyMsg(notifyForm, true, 'You are on the list. We will email you the day the ' + name + ' is back.');
        if (input) input.value = '';
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'rf_back_in_stock', variants: ids.join(',') }); } catch (e) {}
      }, function (e) {
        notifyMsg(notifyForm, false, e && e.email ? 'That email did not go through. Check it and try again.'
                                                  : 'That did not go through. Please try again in a minute.');
      }).then(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ------------------------------------------------------------- render --- */
  var soldOutEverywhere = !V.some(function (v) { return v.available; });

  function sync() {
    renderTiles();
    var atc = q('[data-n-atc]'), atc2 = q('[data-n-atc2]');

    if (soldOutEverywhere) {
      var nf = q('[data-n-notify]');
      if (nf) {
        nf.hidden = false;
        var nm = q('[data-n-notify-name]', nf); if (nm && V[0]) nm.textContent = V.length > 1 ? 'design' : V[0].name;
        var nv = q('[data-n-notify-variant]', nf); if (nv) nv.value = D.title;
      }
      qa('[data-n-price]').forEach(function (el) { el.textContent = 'Sold out'; });
      qa('[data-n-pricenote]').forEach(function (el) { el.textContent = 'Back soon'; });
      if (atc) { atc.disabled = true; var bl = q('[data-n-atclabel]', atc); if (bl) bl.textContent = 'Sold out'; }
      if (atc2) { atc2.disabled = true; atc2.textContent = 'Sold out'; }
      renderBag();
      return;
    }

    var p = primary();
    if (p) {
      qa('[data-n-price]').forEach(function (el) { el.textContent = money(p.price); });
      qa('[data-n-pricenote]').forEach(function (el) { el.textContent = p.name; });
    }
    var fitEl = q('[data-n-fit]');
    if (fitEl) {
      var f = p && p.fit ? p.fit : '';
      fitEl.hidden = !f;
      var ft = q('[data-n-fit-text]', fitEl); if (ft) ft.textContent = f;
    }

    var here = thisInCart();
    if (atc) {
      atc.disabled = !(p && p.available);
      var lbl = q('[data-n-atclabel]', atc);
      if (lbl) lbl.textContent = here ? 'In your bag · add another' : 'Add to bag · ' + money(p ? p.price : 0);
    }
    if (atc2) {
      atc2.disabled = !(p && p.available);
      atc2.textContent = 'Add to bag · ' + money(p ? p.price : 0);
    }
    var ssub = q('[data-n-sticky-sub]');
    if (ssub && p) ssub.textContent = p.name;

    renderBag();
    if (sheet && !sheet.hidden) renderSheet();
  }

  /* ------------------------------------------------------------ add to --- */
  function addThis(btn) {
    var p = primary();
    if (!p || !p.available) return;
    var before = cartCovers();
    if (btn) btn.disabled = true;
    bundleError('');
    cartAdd([{ id: p.id, quantity: 1 }]).then(function () {
      toast('&#10003; Added ' + esc(THIS.t) + ' ' + short(clubName(p.name)) + unlockMsg(before, cartCovers()));
      if (btn) btn.disabled = false;
      sync();
    }).catch(function (err) {
      if (btn) btn.disabled = false;
      bundleError(err.message);
    });
  }
  var atcBtn = q('[data-n-atc]');
  if (atcBtn) atcBtn.addEventListener('click', function () { addThis(atcBtn); });
  var atcBtn2 = q('[data-n-atc2]');
  if (atcBtn2) atcBtn2.addEventListener('click', function () {
    var box = document.getElementById('n-buybox');
    if (box && window.innerWidth < 981) { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    addThis(atcBtn2);
  });
  // Back/forward cache restores the page as it was; the cart may have moved since.
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().then(sync); });

  /* ------------------------------------------------------------ sticky --- */
  var sticky = q('[data-n-sticky]');
  var anchor = document.getElementById('n-buybox');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  }

  /* -------------------------------------------------------- size guide --- */
  // Mike, 2026-10-10: the guide sits on the page under the buy box and every
  // "Size guide" link scrolls down to it, so nobody leaves the page. A page
  // built before that (an old per-product snippet) still opens the pop-up.
  var sg = q('[data-n-sg]'), sgOnPage = document.getElementById('n-sizeguide');
  function sgOpen() {
    if (sgOnPage) { sgOnPage.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (sg) { sg.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function sgClose() { if (sg) { sg.hidden = true; document.body.style.overflow = ''; } }
  qa('[data-n-sg-open]').forEach(function (b) { b.addEventListener('click', function (ev) { ev.preventDefault(); sgOpen(); }); });
  qa('[data-n-sg-close]').forEach(function (b) { b.addEventListener('click', sgClose); });
  if (sg) sg.addEventListener('click', function (ev) { if (ev.target === sg) sgClose(); });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') { sgClose(); closeSheet(); }
  });

  /* ------------------------------------------------- review filter tabs --- */
  qa('[data-n-revfilter]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-n-revfilter');
      qa('[data-n-revfilter]').forEach(function (o) {
        o.classList.toggle('is-on', o === b);
        o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
      });
      qa('[data-n-revcard]').forEach(function (c) {
        c.hidden = key !== 'all' && c.getAttribute('data-n-revcard') !== key;
      });
    });
  });

  /* ------------------------------------------ all reviews (Judge.me) ---- */
  // "Read all N reviews" opens Judge.me's full list, which the page carries
  // hidden after the page body (rf-pdp-next-page.liquid), and scrolls to it.
  var allRev = q('[data-rf-allrev]');
  function openAllRev() {
    allRev.hidden = false;
    allRev.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (allRev) {
    qa('a[href$="#judgeme_product_reviews"]').forEach(function (a) {
      a.addEventListener('click', function (ev) { ev.preventDefault(); openAllRev(); });
    });
    if (location.hash === '#judgeme_product_reviews') openAllRev();
  }

  /* ------------------------------------------------------------- start --- */
  showSlide(firstAvailable && typeof firstAvailable.mediaIndex === 'number' ? firstAvailable.mediaIndex : 0);
  sync();
  fetchCart().then(sync);
})();

/* Any control that just needs to put the buy box back on screen. */
(function () {
  var box = document.getElementById('n-buybox');
  if (!box) return;
  Array.prototype.forEach.call(document.querySelectorAll('[data-n-scrollbuy]'), function (b) {
    b.addEventListener('click', function () { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  });
})();
